import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-policy',
  templateUrl: './terms-policy.component.html',
  styleUrls: ['./terms-policy.component.scss'],
  host: {
    'class': 'container cc-component-container', 
    'id': 'auth-component-backdrop'
  },
})
export class TermsPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
